import { render, staticRenderFns } from "./editGlobalPrivx.vue?vue&type=template&id=2b520354&"
import script from "./editGlobalPrivx.vue?vue&type=script&lang=js&"
export * from "./editGlobalPrivx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports